mutation UpdateMailerConfig($id: ID!, $input: UpdateMailerConfigInput!) {
  updateMailerConfig(id: $id, input: $input) {
    id
  }
}
